<template>
  <div class="ag-container">
    <AgGrid
      :column-defs="columnSpecs"
      :row-double-clicked="handleRowClick"
      :row-data="rowData"
      row-model-type="clientSide"
      pagination="true"
      :pagination-page-size="limit"
      suppress-pagination-panel="true"
      grid-class-name="ag-theme-alpine"
      @open-invoice-approval-ui="openInvoiceApprovalUI"
      @get-grid-data="getGridApi"
    />
    <WfmPagination
      class="pagination"
      :records-showing="recordsShowing"
      :total-rows-count="totalRowsCount"
      :data-test-id="listPaginationDataTestId"
      @get-page="getThePage"
    />
    <WfmLoader v-if="loading" />
  </div>
</template>

<script>
import { ref, reactive, computed, provide, watch, onActivated, onMounted } from 'vue'
import {keys} from '../provideKeys.js'
import { useStore } from 'vuex'
import AgGrid from '../components/AgGrid.vue';
import WfmPagination from '../common/wfm-pagination.vue'
import getUtility from '../composables/getUtility'
import postData from '../composables/postData'
import getFieldOptions from '../composables/getFieldOptions'
import getFormInfo from '../composables/getFormInfo'
import gridConfig from '../composables/getGridData'
import getFatRow from '../composables/fatRowGenerator'
import makeFilter from '../composables/makeFilter'
import getProjections from '../composables/getProjections'
import leavesCreateUtility from '../composables/leavesCreateUtility'
import processRowData from '../composables/processRowData.js';
import WfmLoader from './loader/wfm-loader.vue';
export default {
  name: 'WfmListItems',
  components: {
    AgGrid,
    WfmPagination,
    WfmLoader
  },
  props: {
    listFolder : {
      type: Object,
      default: null
    },
    searchTerm : {
      type : String,
      default : null
    },
    searchPath:{
      type:String,
      default:null
    },
    rowDoubleClicked: {
      type: Function,
      default: () => {}
    },
    pagination : {
      type: Boolean,
      default : true
    },
    suppressPaginationPanel : {
      type : Boolean,
      default : true
    },
    currentTask:{
      type:String,
      default:null
    },
    fieldsToFilter:{
      type:Object,
      default:null
    },
    refreshList:{
      type:Boolean,
      default:false
    },
    currentRowData:{
      type:Object,
      default:null
    },
    showSwFilter:{
      type:Boolean,
      default:false
    }
  },
  emits:['send-grid-api', 'open-invoice-approval-ui'],
  setup(props, context) {
    const store = useStore()
    const { debounce, getNullObject } = getUtility()
    const {projectionForFolder} = getProjections()
    const limit = ref(50)
    const offsetValue = ref(0)
    const bSettings = store.getters['bSettings'];
    const recordsShowing = ref(0)
    const totalRowsCount = ref(0)
    const { fieldsData } = getFieldOptions()
    const { getFormObject, getCurrentTxn } = getFormInfo()
    const { columnDefs } = gridConfig()
    const {getProcessedDataList, getProcessedEmployeeListData} = processRowData()
    const orders = ref()
    const loading = ref(false)
    // transform props as required
    // const folder = ref(folderObjectFromName(props.folder))
    const searchTerm = props.searchTerm
    const searchPath = props.searchPath

    // watch for changes in the props.searchTerm
    watch(() => [props.searchTerm, props.fieldsToFilter], ([newSearchTerm, newFieldsToFilter]) => {
      try {
        // console.log('this searchPath', searchPath)
        handleSearchDebounced(newSearchTerm, searchPath, newFieldsToFilter);
      } catch (error) {
        console.log('er', error)
      }
    },   { deep: true });
    const listCurrentFolder = ref(props.listFolder)

    const listPaginationDataTestId = computed(() => {
      return `${listCurrentFolder?.value?.name}/list/pagination`

    })


    watch(
      () => props.refreshList,
      (oldVal, newVal) => {
        try {
          makeFinalComputedList();
          getData()
        } catch (error) {
          console.error('An error occurred:', error);
        }
      }
    );

    function openInvoiceApprovalUI(params) {
      context.emit('open-invoice-approval-ui', params);
    }

    const handleRowClick = props.rowDoubleClicked || handleRowClickFn
    // Refs
    const txnParams = reactive({})
    const list = ref()
    const columnSpecs = ref()
    const rowData = ref(null)

    const gridApi = ref(null)

    const listFormObject = computed(() => {
      //get the current txn object depending on the txntype
      //get the form object that is needed
      const currentTxn = getCurrentTxn('list', props.listFolder)
      const formName = currentTxn?.form?.form_name ? currentTxn.form?.form_name : currentTxn?.form
      return getFormObject(formName, props.listFolder)
    })

    const fields = computed(() => {
      return props?.listFolder?.fields
    })
    const columnsToShowField = computed(() => {
      const cloneOfFolder = JSON.parse(JSON.stringify(props.listFolder));
      let retVal = []
      retVal = listFormObject.value?.map((each) => {
        return fieldsData(each.path, cloneOfFolder, bSettings.output.data.records[0], each)
      })
      return retVal
    })

    const folderFields = computed(() => {
      if (props.currentTask === 'create') {
        const cloneOfFolderFields = JSON.parse(JSON.stringify(listCurrentFolder.value.fields));
        const emptyFolderFields = getNullObject(cloneOfFolderFields)
        return emptyFolderFields
      }
      else if (props.currentTask === 'update') {
        return props.currentRowData
      }
      else {
        return listCurrentFolder.value.fields
      }
    })
    provide(keys.folderFields, folderFields)

    const partnerId = computed(() => {
      const partner = partnersList.value?.filter((each) => each.code == swhandle.value)
      return partner[0].id;
    })

    const swhandle = computed(() => {
      return store.getters['userModule/swHandle']
    })

    // begin data retrieval and search
    const handleSearchDebounced = debounce(async(searchTerm, searchPath, fieldsToFilter) => {
      await handleSearch(searchTerm, searchPath, fieldsToFilter);
    }, 1000);

    async function handleSearch(searchTerm, searchPath, fieldsToFilter) {
      try {
      // touchListKey()
      //updating the searchTerm to pass to wfmlistItems
      //get the filterParams
        const fieldsToFilterOn = searchTerm != null ? null : fieldsToFilter
        const { generateFilterParams } = makeFilter(
          searchTerm,
          props.listFolder,
          fieldsToFilterOn, //specific fields to search on ,if any.(takes an array like [code,designation , etc])
          searchPath, // if we have searchPath then its possible to generate specific filter params with the path
          true
        )
        const filterParams = generateFilterParams()

        if (searchTerm != null && fieldsToFilter != null) {
          if (fieldsToFilter[0].hasOwnProperty('key')) {
            fieldsToFilter[0]['path'] = `${props.listFolder.name}.${fieldsToFilter?.[0]?.['key']}`;
            delete fieldsToFilter['key'];
          }
          filterParams.filterInput.push(fieldsToFilter[0])
        }
        if (searchTerm && searchTerm.length >= 2 || fieldsToFilter?.length > 0) {
          txnParams.filters = filterParams;
          offsetValue.value = 0;
          await getData();
        // touchListKey()
        } else {
          txnParams.filters = null;
          await getData();
        // touchListKey()
        }
      }
      catch (err) {
        console.log(err)
      }

    }
    //set the grid api and send it further up for use
    function getGridApi(api) {
      gridApi.value = api
      context.emit('send-grid-api', api)
    }
    async function getThePage(paginationParams) {
      limit.value = paginationParams.limit
      offsetValue.value = paginationParams.offset
      gridApi.value.showLoadingOverlay();
      await getData()
    }
    const ascSortToggle = ref(false);
    // const stateToSend = ref()
    function toggleSort(path) {
      // const pathArry = path.split('.')
      // console.log('show', pathArry[pathArry.length - 1])
      ascSortToggle.value = !ascSortToggle.value;
      // stateToSend.value = {pathArry:ascSortToggle.value}

      if (path != null) {
        const orderBy = {
          path:path,
          value:ascSortToggle.value ? 'asc' : 'desc'
        }
        orders.value = orderBy

      }
    }


    watch(orders, async(newValue) => {
      //get list again with orderBy params
      await getData()
    })


    const getData  = async() => {
      console.log('wfm-list-items getData, folder: ',  props.listFolder)
      loading.value = true
      const orderBy = orders.value
      // if (['payslips', 'reports'].includes(props.listFolder.name)) {
      //   //in case of payslips and reports orderby last_modified , rest of the folder order as it is
      //   orderBy = {
      //     path: `${props.listFolder?.name}.last_modified`,
      //     value: 'desc'
      //   }
      // }
      txnParams.refRows = true
      txnParams.page = {
        limitBag: {
          path: `${props.listFolder?.name}.id`,
          limit: limit?.value,
          offset: txnParams.filters === null || offsetValue.value !== 0 ? offsetValue.value : 0
        },
        getRowCountBag: {
          path: `${props.listFolder?.name}.id`,
          value: true
        },
        orderByBag: orderBy
      }
      txnParams.projections = projectionForFolder(props.listFolder.name)

      const { listData } = postData()
      list.value = await listData(props.listFolder, txnParams)
      console.log(list.value)
      if (list.value.output.type === 'error') {
        rowData.value = [];
      } else {
        const fieldsToSend = columnsToShowField.value?.length > 0 ? columnsToShowField.value : fields.value
        const listTableName = 'list'

        if (Object.keys(list.value.output.data.records).length !== 0) {
          const records = list.value.output.data.records
          const idx = records[records.length - 1];
          const dataEnd = idx.dataEnd - 1
          //number of records being shown is dataEnd
          recordsShowing.value = dataEnd
          if (idx.rowCount) {
            //total records present is rowCount
            totalRowsCount.value = idx.rowCount
          }
          else {
            totalRowsCount.value = 0
          }
          const { fatRowGenerator } = getFatRow()
          const listData = fatRowGenerator(list.value)
          const finalList = listData.filter((each) => {
            if (each['deleted'] !== undefined) {
              if (each.deleted === false) {
                return each
              }
            } else {
              return each;
            }
          })
          const hasRows = finalList && finalList.length > 0;
          const rData = getProcessedDataList(props.listFolder, finalList, fieldsToSend)
          if (props.listFolder.name == 'employees' && props.searchTerm == null) {
            rowData.value = await getProcessedEmployeeListData(props.listFolder, rData)
          }
          else if (props.listFolder.name === 'leaves') {
            const {leavesListToShow } = leavesCreateUtility()
            const processedList = leavesListToShow(finalList)
            rowData.value = processedList
          }
          //else if (props.listFolder.name === 'reports') {
          //  rowData.value = finalList
          //}
          else if (['salary_structures'].includes(props.listFolder.name)) {
            rowData.value = rData?.filter((each) => each.partners_id == partnerId.value)
            // rowData.value = rData;
          }
          else if (['partners'].includes(props.listFolder.name)) {
            rowData.value = rData?.filter((each) => each.swHandle != swhandle.value)
          }
          else {
            rowData.value = rData;

          }
          getSwHandle(rowData.value)
          const gridColDefs = columnDefs(fieldsToSend, listTableName, listCurrentFolder.value, ascSortToggle.value, toggleSort, hasRows);
          const baseRowActionIdx = gridColDefs.findIndex((gcd) => gcd.field == 'baseRowActions');
          if (baseRowActionIdx > -1) {
            gridColDefs[baseRowActionIdx].openInvoiceApprovalUI = openInvoiceApprovalUI;
          }
          columnSpecs.value = gridColDefs;
          loading.value = false
          gridApi.value?.setRowData(rowData.value)

        }
        else {
          rowData.value = []
        }

      }
      // the list control needs to refresh after data is recevied
      // touchListKey()
    }

    // end data retrieval and search

    function handleRowClickFn(params) {
      console.log('wfm-list-items handleRowClick: ', params)
    }
    const partnersList = computed(() => store.getters['commonModule/partnersListGetter'])


    function getSwHandle(rowData) {
      rowData.forEach((element) => {
        if (props.listFolder.name != 'partners') {
          const partner = partnersList.value?.filter((each) => each.id == element?.partners_id)
          element.swHandle = partner[0]?.code
        }
        else {
          element.swHandle = element.code
        }

      });
    }

    onActivated(async() => {
      makeFinalComputedList()
      if (props.listFolder.name == 'payslips' && store.state.gen_payslips) {
        await getData();
        store.state.gen_payslips = false;
      }
    });

    function makeFinalComputedList() {
      let renderedRows = null;
      if (gridApi.value) {
        renderedRows = gridApi.value.getModel().rowsToDisplay.map((rowNode) => rowNode.data);
      }
      const fieldsToSend = columnsToShowField.value?.length > 0 ? columnsToShowField?.value : fields?.value
      rowData.value = getProcessedDataList(props?.listFolder, renderedRows, fieldsToSend)
    }

    onMounted(() => {
      if (searchTerm && searchTerm != '') {
        // touchListKey()
        handleSearchDebounced(searchTerm, searchPath)
      }
      else {
        if (!props.showSwFilter) {
          getData()

        }
      }
    })

    return {
      columnSpecs,
      getGridApi,
      handleRowClick,
      rowData,
      getThePage,
      recordsShowing,
      totalRowsCount,
      limit,
      listPaginationDataTestId,
      openInvoiceApprovalUI,
      loading
    };
  }
};
</script>

<style scoped>
.ag-container {
    /* position: absolute; */
    /* height: 78vh; */
    height: 78vh;
    z-index: 0;
    width: 100;
}
.pagination{
    width:100%;
  }
</style>
